import { notification } from 'antd'
import { useQuery } from 'react-query'
import { getRating, listRatings } from './ratingsApi'
import { RatingFilters } from './ratingsModel'

export const useRatingsListQuery = (filters: RatingFilters) => {
  return useQuery({
    queryKey: ['ratings', 'list', filters],
    queryFn: () => listRatings(filters),
    keepPreviousData: true,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load response ratings' })
    },
  })
}

export const useRatingQuery = (ratingId: string | null) => {
  return useQuery({
    queryKey: ['ratings', 'detail', ratingId],
    queryFn: () => getRating(ratingId!),
    enabled: !!ratingId,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load response rating' })
    },
  })
}
